<template>
  <div v-if="error">
    <v-alert
      v-for="(e, index) in error.data.errors"
      :key="index"
      color="error"
      dark
      dense
      >{{ e[0] }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default: null
    }
  }
};
</script>
